import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as urls from "../utility/urls";
import * as dominios from 'src/app/utilitarios/dominios';

function getInstitucionSlug(): string {
  return dominios.mapUrl.get(window.location.host.toString());
}
@Injectable({
  providedIn: 'root'
})
export class PostsService {

  constructor(
    private http: HttpClient,
  ) { }

  getPostList(categoriaSlug: string = ""): Observable<any> {
    let instSlug = getInstitucionSlug();
    let queryParams = new HttpParams();
    queryParams.append('institucion', 'test');
    return this.http.get(environment.rediApi + urls.posts, {
      params: {
        'categoria': categoriaSlug,
        'area' : 'landings-institucionales',
        'institucion': instSlug
      }
    });
  }
  getPostCategories(): Observable<any> {
    let instSlug = getInstitucionSlug();
    return this.http.get(environment.rediApi + urls.getCategorias, {
      params: {
        'institucion': instSlug
      }
    });
  }
  verPost(slug: string): Observable<any> {
    return this.http.get(environment.rediApi + urls.verPost + slug);
  }
}
